import { useContext } from "react";
import { useTranslation } from "react-i18next";
import ReportCard from "components/ReportCard";
import { DefaultTranslationFieldsInTable, SummaryOption } from "constants/constants";
import { CorporateDashboardContext } from "contexts/CorporateDashboardContext/CorporateDashboardContext";
import { IMillReportCardProps } from "pages/Corporate/Locations/MillDashboards/MillDashboardInterfaces";
import { translateDefaultEntity } from "utilities/localesUtilities";
import DowntimeFailureCodeByMill from "../DowntimeFailureCodeByMill/DowntimeFailureCodeByMill.view";
import MachineCentersPopover from "./MachineCentersPopover";
import FunctionalLocationsPopover from "./FunctionalLocationsPopover";
import { useStyles } from "./DowntimeFailureCodeByMillReportCard.styles";

const DowntimeFailureCodeByMillReportCard = ({ countryCode }: IMillReportCardProps) => {
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const {
        selectedFailureType,
        selectedFailureCode,
        selectedMillPopoverData,
        selectedMachineCenterPopoverData,
    } = useContext(CorporateDashboardContext);

    const defaultFailureCodeTranslatedName = translateDefaultEntity(
        i18n.language,
        selectedFailureCode,
        "name",
        DefaultTranslationFieldsInTable.FAILURE_CODE,
    );

    const machineCentersPopoverOpen =
        selectedMillPopoverData !== null && selectedMillPopoverData.summaryOption === SummaryOption.BY_CODE;
    const functionalLocationsPopoverOpen = machineCentersPopoverOpen && selectedMachineCenterPopoverData !== null;

    return (
        <ReportCard
            className={classes.mainWrapper}
            showNoData={!selectedFailureType || !selectedFailureCode}
            noDataTitle={t("corporate_dashboard.downtime_by_failure_code_by_mill.no_data")}
            title={
                selectedFailureCode
                    ? t("corporate_dashboard.downtime_by_failure_code_by_mill.title", {
                          failureCode: defaultFailureCodeTranslatedName,
                      })
                    : t("corporate_dashboard.downtime_by_failure_code_by_mill.title_no_selected")
            }
        >
            <>
                <DowntimeFailureCodeByMill countryCode={countryCode} />
                {machineCentersPopoverOpen && <MachineCentersPopover countryCode={countryCode} />}
                {functionalLocationsPopoverOpen && <FunctionalLocationsPopover countryCode={countryCode} />}
            </>
        </ReportCard>
    );
};

export default DowntimeFailureCodeByMillReportCard;
